export const NOTIFICATION_STORE_KEY = 'NOTIFICATION_STORE';
